// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"612b3533","232":"c2767de8","237":"ef5941f2","357":"0e7f477e","526":"59819029","787":"d4aba7ab","872":"5dcb3d13"}[chunkId] + ".chunk.js";
};